import { render, staticRenderFns } from "./myWorkBrands.vue?vue&type=template&id=463ade06&scoped=true&"
import script from "./myWorkBrands.vue?vue&type=script&lang=js&"
export * from "./myWorkBrands.vue?vue&type=script&lang=js&"
import style1 from "./myWorkBrands.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ade06",
  null
  
)

export default component.exports